<!--
 * @Autor: Aberg
 * @Date: 2022-09-16 10:01:21
 * @LastEditTime: 2022-09-27 14:06:25
 * @Description: 
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="video-list" style="height: 100vh;overflow:auto">
    <Header :columnName="columnName"/>
      <div class="content common-container" v-infinite-scroll="load">
        <ul class="m2 wrap-bottom">
          <li v-for="(item, index) in list" :key="index" @click="goVideoDetail(item.id, item.jump_url)">
            <img :src="item.cover" alt="">
            <p class="text">{{ item.title }}</p>
          </li>
        </ul>
        <!-- <p v-show="total == 0">暂无数据</p> -->
    </div>
    <Footer :class="{'transparent': hideFooter}"/>
  </div>
</template>
<script>
import { topicOpt } from "@/service/api/home";
export default {
  data() {
    return {
      columnId: '',
      columnName: '',
      // total: 0,
      pageInfo: {
        page: 1,
        offset: 30
      },
      hideFooter: false,
      total: 0,
      list: [],
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log(to.params)
    this.columnId = to.params.columnId
    this.columnName = to.params.columnName
    this.list = []
    this.pageInfo.page = 1
    this.getList()
    next();
  },
  created() {
    this.columnId = this.$route.params.columnId
    // console.log(this.$route.params.columnName)
    this.columnName = this.$route.params.columnName
    this.pageInfo.page = 1
    this.getList()
  },
  methods: {
    load() {
      if (this.pageInfo.page * this.pageInfo.offset < this.total) {
        this.pageInfo.page++
        this.getList()
        this.hideFooter = true
      } else {
        this.hideFooter = false
      }
      
    },
    getList() {
      let data = {
        'page': this.pageInfo.page,
        'offset': this.pageInfo.offset,
        'id': this.columnId
      }
      topicOpt('list', data).then(res => {
        this.list = this.list.concat(res.data.data)
        this.total = res.data.count
      })
    },
    goVideoDetail(vid, jump_url) {
      if (jump_url) {
        window.open(jump_url)
        return
      }
      this.$router.push(`/news/detail/${vid}/${this.columnName}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  min-height: calc(100vh - 3.3rem);
}
.m2 {
  padding: 0.3rem 0 0.45rem;
  li {
    margin-top: 0.2rem;
    height: 2.5rem;
  }
}
.transparent {
  opacity: 0;
}
</style>